module.exports = __webpack_public_path__ + "img/symbol_1.eb5878fc.png";